import { useMutation } from "@apollo/client";
import { CONTACTUS_FORM } from "../../graphql/contactus/mutations";
import cssVars from '../../styles/vars.module.scss'
import { useState } from 'react'
import { Box, Button, Grid, TextField, Typography, CircularProgress } from "@mui/material";
import useTranslation from "../../hooks/useTranslation";
import { validateEmail } from "../../helpers/validation";
import { useSnackbar } from "notistack";
import json2mq from 'json2mq';
import useMediaQuery from '@mui/material/useMediaQuery';
import CustomMetas from "../../components/custom-metas/customMetas";
import { useTheme } from "@mui/material";

const ContactUs = () => {
    const { t } = useTranslation()
    const { enqueueSnackbar } = useSnackbar()
    const [formCheck, setFormCheck] = useState(false)
    const [customerInfos, setCustomerInfos] = useState({ email: "", comment: "", name: "", telephone: "" })

    const isMD = useMediaQuery(
        json2mq({
            minWidth: 769,
        }),
    );

    const [contactUs, { data, loading, error }] = useMutation(CONTACTUS_FORM)

    const handleSubmit = (e) => {
        setFormCheck(true)
        e.preventDefault()
        if (e.target.checkValidity() && validateEmail(customerInfos.email)) {
            contactUs({
                variables: {
                    email: customerInfos.email,
                    telephone: customerInfos.telephone,
                    name: customerInfos.name,
                    comment: customerInfos.comment
                },
                onCompleted: () => {
                    enqueueSnackbar(t("Your message has been sent successfully"), { variant: 'success' });
                    setCustomerInfos({ name: "", email: "", telephone: "", comment: "" })
                    setFormCheck(false)
                }

            })
        }
    }
    const theme = useTheme()

    return (
        <>
            <CustomMetas title={t("Contact us")}
                description={t("Contact us")}
                keywords={t("contact us, reach, connect, call")}
                path="contact-us.html"
                page_type="catalogs"
            />
            <Box component="form" onSubmit={handleSubmit} autoComplete="off" >
                <Grid item container columns={150} justifyContent="center" >
                    <Grid item xs={150} md={75} sx={{ px: { xs: 2, md: 0 } }} >
                        <Typography sx={{ fontWeight: 600, fontSize: "24px" }} variant="span">{t("Send Us A Message")}</Typography>
                        <Grid container item columns={12} position="relative" >

                            <Grid item xs={12} sx={{ mt: 4 }} >
                                <TextField
                                    label={t("Name")}
                                    placeholder="ex: john"
                                    fullWidth
                                    value={customerInfos.name}
                                    className="custom-input"
                                    type="text"
                                    error={formCheck && !customerInfos.name}
                                    onChange={(e) => { setCustomerInfos({ ...customerInfos, name: e.target.value }) }}
                                />
                                <Grid className="form-error" display={formCheck && !customerInfos.name ? "block" : "none"} sx={{ color: cssVars.red }} >{t("Name is required")}</Grid>
                            </Grid>

                            <Grid item xs={12} sx={{ mt: 4 }} >
                                <TextField
                                    label={t("Email")}
                                    placeholder="example@example.com"
                                    fullWidth
                                    value={customerInfos.email}
                                    className="custom-input"
                                    type="email"
                                    error={formCheck && !validateEmail(customerInfos.email)}
                                    onChange={(e) => { setCustomerInfos({ ...customerInfos, email: e.target.value }) }}
                                />
                                <Grid className="form-error" display={formCheck && !customerInfos.name ? "block" : "none"} sx={{ color: cssVars.red }} >{t("Email is required")}</Grid>
                            </Grid>

                            <Grid item xs={12} sx={{ mt: 4 }} >
                                <TextField
                                    label={t("Telephone")}
                                    placeholder="ex: 780-924-6628"
                                    fullWidth
                                    value={customerInfos.telephone}
                                    className="custom-input"
                                    type="text"
                                    error={formCheck && !customerInfos.telephone}
                                    onChange={(e) => { setCustomerInfos({ ...customerInfos, telephone: e.target.value }) }}
                                />
                            </Grid>

                            <Grid item xs={12} sx={{ mt: 4 }} >
                                <TextField
                                    label={t("Comments")}
                                    multiline
                                    fullWidth
                                    value={customerInfos.comment}
                                    type="text"
                                    rows={isMD ? 7 : 4}
                                    error={formCheck && !customerInfos.comment}
                                    onChange={(e) => { setCustomerInfos({ ...customerInfos, comment: e.target.value }) }}
                                />
                                <Grid className="form-error" display={formCheck && !customerInfos.name ? "block" : "none"} sx={{ color: cssVars.red }} >{t("Comment is required")}</Grid>
                            </Grid>

                            <Grid item xs={12} display="flex" justifyContent="center" >
                                <Button
                                    sx={{
                                        width: { xs: "100%", md: "20%" },
                                        mt: 4,
                                        fontSize: "16px",
                                        py: "1.4rem !important",
                                        backgroundColor: `${!loading ? theme.palette.primary.main : cssVars.darkGray} ! important`,
                                        color: `${cssVars.white} ! important`,
                                        border: `1px solid ${!loading ? theme.palette.primary.main : cssVars.darkGray} ! important`,
                                        borderRadius: `${cssVars.radius} ! important`,
                                        ':hover': {
                                            bgcolor: `${!loading ? theme.palette.primary.dark : cssVars.darkGray} ! important `,
                                            borderColor: `${!loading ? theme.palette.primary.dark : cssVars.darkGray} ! important`,
                                            color: `${cssVars.white} ! important`
                                        },
                                        textTransform: 'unset'
                                    }}
                                    type="submit"
                                    disabled={loading}
                                >
                                    {t("Submit")}
                                    {loading ? <CircularProgress sx={{ ml: 1 }} style={{ width: "15px", height: "15px", color: cssVars.white }} /> : null}
                                </Button>
                            </Grid>

                        </Grid>
                    </Grid>
                </Grid>
            </Box>
        </>

    );
}

export default ContactUs;